// extracted by mini-css-extract-plugin
export default {"mobile":"MobileInstallCol_mobile","mobileStoreButtons":"MobileInstallCol_mobileStoreButtons","mockUp":"MobileInstallCol_mockUp"};